module.exports = __webpack_public_path__ + "static/apache-hadoop-90276d3abdbc9f0d926139847299b010.svg";